<template>
  <div
    ref="root"
    class="deferred-mount-root"
    :style="rootStyle"
  >
    <slot v-if="active" />
  </div>
</template>

<script>
export default {
  name: 'DeferredMount',
  props: {
    /** Altura mínima reservada hasta montar (reduce CLS) */
    minHeight: {
      type: String,
      default: '200px',
    },
    rootMargin: {
      type: String,
      default: '240px 0px 320px 0px',
    },
    threshold: {
      type: Number,
      default: 0.01,
    },
  },
  emits: ['activate'],
  data() {
    return {
      active: false,
      io: null,
    };
  },
  computed: {
    rootStyle() {
      return this.active ? null : { minHeight: this.minHeight };
    },
  },
  mounted() {
    const el = this.$refs.root;
    if (!el) {
      this.activate();
      return;
    }
    if (typeof IntersectionObserver === 'undefined') {
      this.activate();
      return;
    }
    this.io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          this.activate();
        }
      },
      { rootMargin: this.rootMargin, threshold: this.threshold }
    );
    this.io.observe(el);
  },
  beforeUnmount() {
    if (this.io) {
      this.io.disconnect();
      this.io = null;
    }
  },
  methods: {
    activate() {
      if (this.active) return;
      if (this.io) {
        this.io.disconnect();
        this.io = null;
      }
      this.active = true;
      this.$emit('activate');
    },
  },
};
</script>
